module.exports = __webpack_public_path__ + "img/diet.aca88ef7.png";